/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Schema_S4_Li4Inputs */

const en_guide_json_schema_s4_li4 = /** @type {(inputs: Guide_Json_Schema_S4_Li4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>Configuration</strong>: VS Code uses JSON Schema to provide autocomplete for settings.json`)
};

const ko_guide_json_schema_s4_li4 = /** @type {(inputs: Guide_Json_Schema_S4_Li4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>설정</strong>: VS Code가 JSON Schema를 사용하여 settings.json에 자동 완성 제공`)
};

const ja_guide_json_schema_s4_li4 = /** @type {(inputs: Guide_Json_Schema_S4_Li4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>設定</strong>: VS CodeはJSON Schemaを使用してsettings.jsonの自動補完を提供`)
};

/**
* | output |
* | --- |
* | "<strong>Configuration</strong>: VS Code uses JSON Schema to provide autocomplete for settings.json" |
*
* @param {Guide_Json_Schema_S4_Li4Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_schema_s4_li4 = /** @type {((inputs?: Guide_Json_Schema_S4_Li4Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Schema_S4_Li4Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_schema_s4_li4(inputs)
	if (locale === "ko") return ko_guide_json_schema_s4_li4(inputs)
	return ja_guide_json_schema_s4_li4(inputs)
});